import styled from 'styled-components';
import Grid from 'styled-components-grid';
import breakpoint from 'styled-components-breakpoint';

import {
  py, pb, p, pt, pl, pr, px, ml, mb, mt, mr, mx, my
} from 'styled-components-spacing';

import { fontLinkGreen } from '@styles/typography';

import { button } from '@styles/buttons';
import theme from '@theme';

import { Button } from '@components';

const { borderRadius, colors } = theme;

export const StyledCover = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;

  ${breakpoint('desktop')`
    padding-bottom: ${props => (props.formName ? '0px' : '60px')};
    padding-bottom: ${props => props.isModal && '15px'}
  `}
`;

export const StyledContentTop = styled.div`
  color: ${colors.darkBlue};
  width: 70%;
  position: relative;
  display: flex;
  flex-direction: column;

  & > div {
    flex: 1;
  }

  ${breakpoint('mobile', 'tablet')`
    width: 100%;
  `}

  ${breakpoint('tablet', 'desktop')`
    ${props => (props.formName || props.isModal) && 'width: 100%;'}
  `}

  ${breakpoint('desktop')`
    ${props => (props.formName ? p(2) : p(4.5))}
    ${props => props.formName && 'width: 100%;'}
    ${props => props.isModal && 'width: 90%;'}
    ${props => (props.formName || props.isModal ? mt(0) : mt(4))}
    ${props => props.isModal && p(0)}
    
    background-color: ${props => (props.formName ? 'unset' : colors.white)};
    ${borderRadius.medium}
    color: ${colors.black};
  `}
`;

export const StyledContentBottom = styled.div`
  ${pt(4)}
  ${p(3.5)}
  text-align: center;

  ${breakpoint('desktop')`
    ${p(0)}
    ${py(3.5)}
  `}
`;

export const StyledInterviewWrapper = styled(Grid.Unit)`
  ${px(2)}
  ${pb(2)}
  form {
    width: 100% !important;
  }

  flex: 1;

  ${breakpoint('mobile', 'tablet')`
    width: 100%;
  `}

  ${breakpoint('desktop')`
    ${px(0)}
    ${pb(0)}

    display: flex;

    align-items: center;
    justify-content: center;
  `}
`;

export const StyledGrid = styled(Grid)`
  ${breakpoint('desktop')`
    margin: -0.5rem;
  `}
`;

export const StyledLabel = styled.label`
  ${ml(3.5)}
  font-size: 14px;
  font-weight: 600;

  ${breakpoint('desktop')`
    ${ml(0)}
  `}
`;

export const StyledItem = styled(Grid.Unit)`
  ${mb(3.5)}
  ${breakpoint('desktop')`
    padding: 0.5rem;
    ${mb(0)}
  `}
`;

export const StyledFormUnit = styled(Grid.Unit).attrs({
  size: { mobile: 6 / 12, desktop: 6 / 12 }
})`
  ${pb(3)}

  ${breakpoint('mobile', 'desktop')`
    input{
      border-radius: 10px;
    }
    

    &:nth-child(odd) {
      ${props => (props.treatmentFormName ? pl(2) : pr(2))}
    }

    &:nth-child(even) {
      ${props => (props.treatmentFormName ? pr(2) : pl(2))}
    }
  `}

  ${breakpoint('desktop')`
    &:nth-child(odd) {
      ${props => (props.treatmentFormName ? pl(2) : pr(4))}
    }

    &:nth-child(even) {
      ${props => (props.treatmentFormName ? pr(2) : pl(4))}
    }

    ${props =>
    props.treatmentFormName
      && `
    input{
      border-radius: 10px;
    }
    `}
  
  `}
`;

export const StyledEmailFormUnit = styled(Grid.Unit)`
${pb(3)}

.flag-dropdown{
      border: none !important;
      background-color: unset !important;
    }

    ${props =>
    (props.treatmentFormName
      ? `
      .react-tel-input{
      input{
        border: none !important;
      }
    }
    `
      : `
    .react-tel-input{
      input{
        border: 1px solid ${colors.translucentDarkBlue} !important;
      }
    }
    `)}

${breakpoint('mobile', 'desktop')`
    input{
      border-radius: 10px;
    }

    
    .react-tel-input{
      input{
        border-radius: 10px !important;
      }
    }
`}

${breakpoint('desktop')`
  &:nth-child(odd) {
      ${props => (props.treatmentFormName ? pl(2) : pr(4))}
    }

    &:nth-child(even) {
      ${props => (props.treatmentFormName ? pr(2) : pl(4))}
    }

    ${props =>
    props.treatmentFormName
      && `
    input{
      border-radius: 10px;
    }

    .form-control{
      border-radius: 10px !important;
      
    }

    `}
`}
 .flag-dropdown{
      border: none;
    }

    ${props =>
    (props.treatmentFormName
      ? `
      .react-tel-input{
      input{
        border: none !important;
      }
    }
    `
      : `
    .react-tel-input{
      input{
        border: 1px solid ${colors.translucentDarkBlue};
      }
    }
    `)}

`;

export const StyledItemDetails = styled(Grid.Unit)`
  padding: 0.5rem;
`;

export const StyledInput = styled.input`
  ${borderRadius.small}
  ${p(2.5)}
  ${pl(3.5)}
  ${mt(2)}

  background-color: ${colors.greyBlue10};
  font-size: 1rem;
  display: block;
  width: 100%;
  border: 0;
  
  ${breakpoint('desktop')`
    ${pl(2.5)}
    background-color: ${colors.white};
  `}
`;

export const StyledFormIntro = styled.p`
  ${mb(3.5)}
  ${mx(3.5)}
  font-size: 18px;
  line-height: 1.44;

  ${breakpoint('desktop')`
    ${mx(0)}
  `}
`;

export const StyledSeparator = styled.div`
  background: ${colors.formSeparator};
  width: 100%;
  height: 1px;

  ${breakpoint('desktop')`
    width: 1px;
    height: auto;
  `}
`;

export const StyledItemSeparator = styled(Grid.Unit)`
  ${pb(3)}
  display: flex;
  justify-content: center;

  ${breakpoint('desktop')`
    ${py(0)}
    ${pt(4.5)}
    ${pb(4)}
  `}
  ${breakpoint('mobile', 'desktop')`
    margin-bottom: 1rem;
    visibility: hidden;
  `}
`;

export const StyledItemIncome = styled(Grid.Unit)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${breakpoint('mobile', 'desktop')`
    display: none;
  `}
`;

export const StyledHeadlineTextIncome = styled.h3`
  ${my(4)}
  font-weight: 600;
  font-size: 30px;

  text-align: center;

  ${theme.typography.OpenSans}

  ${breakpoint('desktop')`
    ${mt(0)}
    font-size: 40px;
  `}
`;

export const StyledIncomeCopy = styled.span`
  display: none;
  ${mb(3)}

  font-size: 14px;
  line-height: 22px;
  white-space: pre-wrap;

  text-align: center;

  &:last-child {
    text-align: left;
    ${mb(0)}
  }

  ${breakpoint('desktop')`
    display: flex;
  `}
`;

export const StyledTermsAndConditionsWrapper = styled.div`
  ${mb(3.5)}
  display: flex;
  align-items: center;

  ${breakpoint('desktop')`
    ${mb(2.5)}
  `}
`;

export const StyledTermsAndConditionsSpan = styled.span`
  text-align: left;
`;

export const StyledCheckboxWrapper = styled.label`
  ${mr(3)}
  label {
    background-color: ${colors.greyBlue10};
  }
`;

export const StyledLink = styled.a`
  ${fontLinkGreen}
  text-decoration: underline;
`;

export const StyledButton = styled(Button)`
  ${button}
  display: inline;
`;
